import {
    apiRequest,
    notificationList,
    notificationFlagRead
} from "../../../../../services/adapters/base"

class DataTableRepository {

    fetchRowTable = async (query, cancelToken) => {
        return await apiRequest("get", notificationList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchFlagRead = async (query) => {
        return await apiRequest("post", notificationFlagRead, {
            body: query
        }, true)
    }

}

export default DataTableRepository